import { render } from "./RegistrationHelpComponent.vue?vue&type=template&id=45c2c457&scoped=true"
import script from "./RegistrationHelpComponent.vue?vue&type=script&lang=js"
export * from "./RegistrationHelpComponent.vue?vue&type=script&lang=js"

import "./RegistrationHelpComponent.vue?vue&type=style&index=0&id=45c2c457&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45c2c457"]])

export default __exports__